module.exports = __webpack_public_path__ + "img/donwloadIos.71cc70cc.png";